import { render, staticRenderFns } from "./aflDescargar.vue?vue&type=template&id=653e3e0e&"
import script from "./aflDescargar.vue?vue&type=script&lang=js&"
export * from "./aflDescargar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports